var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['iconContainer', _vm.className]},[_c('i',{staticClass:"svg-icon",class:`iconfont-v3 ${_vm.iconClass}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }